import {assertAndContinue} from 'Asserts';
import {makeReactContext} from 'lib/makeReactContext';

const DiagramPanningContext = makeReactContext(() => {
  assertAndContinue(
    false,
    'Could not find diagram panning context while rendering analytics component, defaulting to false'
  );
  return false;
}, 'DiagramPanningContext');

export function useDiagramPanningContext(): boolean {
  return DiagramPanningContext.useContext();
}

export default DiagramPanningContext;
